module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1054-be03abedb3b501e42356405f8c5fc52f.png";